<template>
   <v-container fluid> 
        <v-row style="top: 60px; position: fixed; z-index:10; background-color: #f8f8f8; padding-top:4px; margin-left: -30px; width:100%" v-if="!apiLoading">
            <div class="function-alert" style="display:flex; align-items: center; justify-content: flex-start; padding: 18px 23px; width: 80%;">
                <h2 v-if="currentModule.title" style="white-space: nowrap">
                    {{st(currentModule.title)}}
                    <v-tooltip bottom style="z-index:500">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="grey lighten-1" style="cursor:pointer;" class="pl-1 pointer" dense v-bind="attrs" v-on="on">info</v-icon>
                        </template>
                        <span>{{st(currentModule.description)}}</span>
                    </v-tooltip>
                </h2>
                <div v-if="licenseTypeAlert !== ''" class="ml-4 d-flex align-center" style="max-width: 100%; padding: 5px 10px; border-radius: 6px; background-color: #FFF3E0;">
                    <v-icon color="#FFA726">warning</v-icon>
                    <span v-if="licenseTypeAlert === 'BC'" class="ml-2" style="color: #424242; font-size: 0.9em;">{{ st('wkt.admin.common.license-alert.title') }}</span> <!-- BUSINES O CORPORATE -->
                    <span v-if="licenseTypeAlert === 'C'" class="ml-2" style="color: #424242; font-size: 0.9em;">{{ st('wkt.admin.common.license-alert.access.title') }}</span> <!-- SOLO CORPORATE -->		  
                </div>
                <a v-if="moduleNotEnabledToEmployees" :href="moduleDisabledChipHref" class="ml-4" style="max-width: 100%; height: 30px; font-size: 0.9em; text-decoration: none; color: #424242; padding: 5px 10px; border-radius: 15px; background-color: #FFEBEE;">
                    {{st('wkt.admin.common.module_disabled_chip')}}
                </a>
            </div>
        </v-row>

        <v-row v-if="apiLoading">
            <v-col cols="12" >
                <v-skeleton-loader
                type="table-tbody"
                ></v-skeleton-loader>
            </v-col>
        </v-row>

        <v-row style="padding-top:0; margin-top: -24px;" v-if="!apiLoading">
            <v-col cols="12" v-if="this.accessAllowed">
                <EntityWrapper 
                    ref="enityWrapper" :config="currentModule" :context="context" v-on:edit-action="(action) => onEditAction(item, index, action)" @show-alert="doShowAlert($event)" />
            </v-col>
            <v-col cols="12" v-if="!this.accessAllowed">
                <div class="transparent empty-state center-align">
                    <div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
                        <div class="text-center">
                            <i class="large material-icons" style="cursor: pointer;">table_chart</i>
                            <h4>{{ $t('wkt.admin.em.main.empty-title') }}</h4>
                            <p>{{ $t('wkt.admin.em.main.empty-subtitle') }}</p>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                <span style="color: #ffffff;">{{alertText}}</span>
                <v-btn text @click="showAlert=false">
                <span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
                </v-btn>
            </v-snackbar>
    </v-container>
</template>

<script> 

import EntityWrapper from "./em/EntityWrapper";
import BaseModule from '../common/BaseModule.js'
import api from '../../api/worktime';
import gwt from '../../api/gwt';

export default {
  name: 'EMModule',
  mixins: [BaseModule],
  components: { 
    EntityWrapper
  },
  
  data() {
      return { 
        allModules: [],
        accessAllowed: true,
        licenseTypeAlert: false,
        moduleNotEnabledToEmployees: false,
        moduleDisabledChipHref: '#gcustomize;nextTab=tab2',
        showAlert: false,
        alertColor: 'error',
        alertText: '',
        moduleId: '',
        alertTimeout: 3000,
        apiLoading: true,
        moduleLoading: false,
        context: {},
        currentModule: {}
      }
  },
   methods: {
    getModules() {
                if(this.moduleLoading) {
                    return;
                }
				this.apiLoading = true;
                this.moduleLoading = true;
		
				api.getModules(
                    data => {
                            this.allModules = data;
                            this.moduleLoading = false;
                            this.loadModule();
                    }, err => {
                            this.moduleLoading = false;
                            this.apiLoading = false;
                            console.log(err);
                            this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
                    });
		},
        refreshModule() {
            this.$refs.enityWrapper.refreshData();
        },
    loadModule() {

        let profile = gwt.getSessionProfile();
        let sessionInformation = gwt.getSessionInformation();
        let isSuperAdmin = sessionInformation?sessionInformation.employee.isSuperAdmin:false;
    
        let module = this.allModules.find(m=>m.id==this.moduleId);
        this.currentModule = module?module:{};

        //revisamos permisos
        this.accessAllowed = module && (isSuperAdmin || !this.currentModule.rolesAllowed || this.matchRole(profile,this.currentModule.rolesAllowed.split(',')));
        
        //mostramos alerta de tipo de licencia?
        this.licenseTypeAlert = this.checkLicenseTypeByModule(this.moduleId, sessionInformation.company.licenseType);

        this.moduleNotEnabledToEmployees = this.isNotEnabledToEmployeesByModule(this.moduleId, sessionInformation.company);
        this.moduleDisabledChipHref = this.getModuleDisabledChipHref(this.moduleId);

        console.log(`loadModule() called! - company.licenseType: ${sessionInformation.company.licenseType}`);
        console.log(`loadModule() called! - licenseTypeAlert: ${this.licenseTypeAlert}`);
        console.log(`loadModule() called! - moduleNotEnabledToEmployees: ${this.moduleNotEnabledToEmployees}`);

        this.apiLoading = false;
    },
    onReveal(payload) {

        let profile = gwt.getSessionProfile();

        if (!profile) { //todavía no se ha inicializado la aplicación
            return;
        }

        this.context = payload;

        //let sessionInformation = gwt.getSessionInformation();
    
       if (this.mustRefresh() || !this.allModules || this.allModules.length==0) { // Primer acceso
            this.moduleId=payload.moduleId;
            this.getModules();
        } else if (this.moduleId!=payload.moduleId) { // hemos cambiado de módulo
            this.moduleId=payload.moduleId;
            this.loadModule();
        }
        
    },
    doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
   }
};
</script>
